import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { eqIgnoreCase } from '@arcxmoney/arcx-core'
import { poll } from '@arcxmoney/arcx-react'
import { useEffect, useState } from 'react'
import { GraphService, Synth } from 'src/services/GraphService'

export const useSynths = (apolloClient: ApolloClient<NormalizedCacheObject>) => {
  const [synths, setSynths] = useState<Synth[]>([])
  useEffect(() => {
    const graphService = new GraphService(apolloClient)

    return poll(async () => {
      const sortedSynths = (await graphService.fetchSynths()).sort()
      setSynths((prevSynths) =>
        JSON.stringify(prevSynths) === JSON.stringify(sortedSynths) ? prevSynths : sortedSynths,
      )
    }, 5000)
  }, [apolloClient])

  const getSynth = (id: string) => synths.find((synth) => eqIgnoreCase(id, synth.id))
  const getSynthByContainingName = (name: string) =>
    synths.filter((synth) => synth.name.toLowerCase().indexOf(name.toLowerCase()) !== -1)

  return {
    getSynth,
    getSynthByContainingName,
    synths,
  }
}

export function getSynthBySyntheticAddress(synths: Synth[], address: string) {
  return synths.find(({ syntheticAddress }) => syntheticAddress === address)
}
